export default __webpack_public_path__ + "static/media/avatardefault.8ad452b2.svg";